import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_72: FaireProductEntity = {
  token: "legacy_prod_abbott-72",
  type: "product",
  name: "Multi Cats Lined Notebook A5",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/82aaefb88438c399983458074fdce8d054e827bae856705271acbcbb11cc6e60.jpeg",
  priceDollars: 10,
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_stationery-writing"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
